import React from 'react';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';
import Tag from './Tag';

const proxyOnClickOption = options => arg =>
  options.map(option => ({
    ...option,
    onClick: e => option.onClick.call(e, arg),
  }));

const EditTags = ({
  taggings,
  onCreateTagging,
  getTag,
  tagsPath,
  tagOptions,
  toggleEditing,
  queryParam,
  mapResponseToSuggestions,
  filterSuggestions,
}) => (
  <div>
    <RemoteAutoComplete
      onSuggestionSelected={onCreateTagging}
      placeholder="Add a tag by Name"
      className="NewInput NewInput--light NewInput--fw mb-16"
      queryParam={queryParam}
      url={tagsPath}
      mapResponseToSuggestions={mapResponseToSuggestions}
      filterSuggestions={filterSuggestions}
    />
    {taggings.map(tagging => {
      const options = proxyOnClickOption(tagOptions)(tagging);
      const tag = getTag(tagging);
      return <Tag {...tag} key={tag.id} options={options} editing />;
    })}
    <div className="d-f jc-e ai-c mt-16">
      <button
        type="button"
        className="ml-16 NewButton NewButton--blue NewButton--wide NewButton--center"
        onClick={toggleEditing}
        children="Done"
      />
    </div>
  </div>
);

export default EditTags;
